import * as React from 'react';
import NewVendorReportTabPanel2025 from './NewVendorReportTabPanel2025';
import { RouteComponentProps } from 'react-router';
export class NewVendorReport2025 extends React.Component<RouteComponentProps<{}>, { }> {
    public render() {
        console.log(this.props)
        return <div className="new-vendor-report2025">
            <NewVendorReportTabPanel2025 {...this.props} />
        </div>;
    }
}